export default (loanApplicationId = null) => ({
    loanApplicationId,
    street: '',
    secondaryLine: '',
    city: '',
    state: '',
    postalCode: '',
    county: ''
});